import React, { Component } from 'react'
import PropTypes from 'prop-types'

import HomeIcon from 'grommet/components/icons/base/Home'

import Button from './Button'

class HomeButton extends Component {
  render () {
    const {
      isRoot,
      history
    } = this.props

    if (isRoot) return null
    return (
      <Button
        history={history}
        icon={<HomeIcon />}
        label='Home'
        path='/'
        primary />
    )
  }
}

HomeButton.propTypes = {
  isRoot: PropTypes.bool
}

export default HomeButton



// WEBPACK FOOTER //
// ./src/components/HomeButton.js